query PersonalPoolAvailableDocumentTypes {
  personalPoolAvailableDocumentTypes {
    nodes {
      id
      documentType
    }
  }
}
